import { ReactNode } from 'react'
import { useStyles } from './QuestionnaireHeaderLabels.styles'

export const QuestionnaireHeaderLabels = ({
  identity,
  children
}: {
  identity?: ReactNode
  children?: ReactNode
}) => {
  const { classes } = useStyles()
  return (
    <div
      className={classes.labels}
      role="group"
      aria-label="Questionnaire header labels"
    >
      {identity && <div className={classes.identity}>{identity}</div>}
      {children}
    </div>
  )
}
